import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

function authHeaders() {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token no encontrado");
  return { Authorization: `Bearer ${token}` };
}

export const listSkillAgentClientInfos = async (params = {}) => {
  const response = await axios.get(`${API_URL}/api/skill-agent-client-infos`, {
    headers: authHeaders(),
    params,
  });
  return response.data;
};

export const getSkillAgentClientInfoById = async (id) => {
  const response = await axios.get(
    `${API_URL}/api/skill-agent-client-infos/${id}`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const createSkillAgentClientInfo = async (payload) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-client-infos`,
    payload,
    { headers: authHeaders() },
  );
  return response.data;
};

export const updateSkillAgentClientInfo = async (id, payload) => {
  const response = await axios.patch(
    `${API_URL}/api/skill-agent-client-infos/${id}`,
    payload,
    { headers: authHeaders() },
  );
  return response.data;
};

export const deleteSkillAgentClientInfo = async (id) => {
  const response = await axios.delete(
    `${API_URL}/api/skill-agent-client-infos/${id}`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const uploadSkillAgentClientInfoItems = async (id, files) => {
  const body = new FormData();
  const list = Array.from(files || []);
  for (const file of list) {
    body.append("files", file, file.name);
  }
  const response = await axios.post(
    `${API_URL}/api/skill-agent-client-infos/${id}/items`,
    body,
    {
      headers: authHeaders(),
      timeout: 180000,
      maxBodyLength: Infinity,
      maxContentLength: Infinity,
    },
  );
  return response.data;
};

export const deleteSkillAgentClientInfoItem = async (id, itemId) => {
  const response = await axios.delete(
    `${API_URL}/api/skill-agent-client-infos/${id}/items/${itemId}`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const fetchSkillAgentClientInfoItemBlob = async (id, itemId) => {
  const response = await axios.get(
    `${API_URL}/api/skill-agent-client-infos/${id}/items/${itemId}/file`,
    { headers: authHeaders(), responseType: "blob" },
  );
  return response.data;
};
